export default __webpack_public_path__ + "static/media/pxgroup07.17572ee9.png";